// @ts-nocheck
export interface IAlternateDeliverabilityDetails {
  name?: string;
  phone?: string;
  website?: string;
}

export enum IDeliverabilityStatus {
  DELIVERABLE = "DELIVERABLE",
  DELIVER_ALTERNATE = "DELIVER_ALTERNATE",
  DELIVER_SUPPLIER = "DELIVER_SUPPLIER",
  UNDELIVERABLE = "UNDELIVERABLE",
}

export interface IBottleDeliverability {
  status: IDeliverabilityStatus;
  alternateDeliveryDetails?: IAlternateDeliverabilityDetails;
}

export interface IDeliverability {
  exchange: IBottleDeliverability;
  refill: IBottleDeliverability;
}
